// iOS segmented control.
export function Segmented({ value, options, onChange, testId }) {
  return (
    <div data-testid={testId} className="inline-flex rounded-[9px] bg-[rgba(118,118,128,0.12)] p-[2px]">
      {options.map(([v, l]) => (
        <button key={v} type="button" data-testid={`${testId}-${v}`} onClick={() => v !== value && onChange(v)}
          className={`min-w-[72px] rounded-[7px] px-3 py-1 text-[13px] ${v === value ? "bg-white font-semibold text-black shadow-[0_3px_8px_rgba(0,0,0,0.12),0_3px_1px_rgba(0,0,0,0.04)]" : "font-medium text-black"}`}>{l}</button>
      ))}
    </div>
  );
}
